var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 3.25,
    width: 23.5,
    height: 17.5,
    rx: 2.75,
    fill: "#F7F7F7",
    stroke: "#C4C4C4",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3459 7.68744H14.3149L12.8952 9.88759H8.91998L9.3459 7.68744Z",
    fill: "#F2AB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.031 7.68755L15.5927 7L15.4507 8.78762L12.8952 9.8877L14.031 7.68755Z",
    fill: "#C68F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5927 7H19L17.7222 9.20015H14.4569L15.5927 7Z",
    fill: "#F2AB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40852 11.1391H12.1462L10.6511 14.0653H7.95999L8.40852 11.1391Z",
    fill: "#DC0035"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0715 11.1666L13.3443 10.5197L12.1627 13.2875L10.6512 14.0653L12.0715 11.1666Z",
    fill: "#B5002B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3423 10.523H17.08L15.5849 13.2952H12.1463L13.3423 10.523Z",
    fill: "#DC0035"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46769 15.3568H9.80615L8.24718 17.4569H7L7.46769 15.3568Z",
    fill: "#1E3E8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5846 15.3802L10.7981 14.8289H10.9896L9.8224 16.7941L9.63135 16.8143L8.25342 17.457H8.18152L9.5846 15.3802Z",
    fill: "#153070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8342 14.8318H14.5664L13.0895 16.8007H9.65845L10.8342 14.8318Z",
    fill: "#1E3E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVale);
export default __webpack_public_path__ + "static/media/vale.f0efe9a06d5523fc7616bdf7402babb8.svg";
export { ForwardRef as ReactComponent };